module.exports = __webpack_public_path__ + "img/plot_20_accent.63126c50.png";